// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"styles_headerLogo__6dDbk","headerLogo__xmas":"styles_headerLogo__xmas__UWJXS"};